/* eslint-disable jsx-a11y/img-redundant-alt */
import { CSSProperties, FC } from 'react';
import { textColor } from '..';
import Text from '../text';

interface IProps {
  height?: number;
  text?: string;
  style?: CSSProperties;
  textStyle?: CSSProperties;
}

const NotFoundComponent: FC<IProps> = ({ height, text, style, textStyle }) => {
  return (
    <div
      className="flex flex-col items-center py-10 justify-center"
      style={{ height: `${height}px`, ...style }}
    >
      <img
        src="/images/no-data.svg"
        alt="No bookinigs found image"
        width={250}
        height={250}
      />
      <Text
        color={textColor.light}
        style={{
          fontSize: '1rem',
          fontWeight: 500,
          letterSpacing: '0.5px',
          ...textStyle,
        }}
      >
        {text || 'Sorry no records available please check after some times!!'}
      </Text>
    </div>
  );
};

export default NotFoundComponent;
